
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const AgentDefCrudService = function(props: 
  CrudServiceProps<api.AgentDef,string>
) {
  
  return CrudApiService<api.AgentDef,string>({...props, api: api, entityName: 'AgentDef'});

};